import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { InAppTemplate } from "../../../shared/templates/inapp";
import { Formik, Form, Field, FormikProps, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { TableComponent } from "../../../shared/components/table"

import Modal from 'react-bootstrap/Modal'

import TeamIco from "../../../assets/team.svg"
import FilterIco from "../../../assets/filter.svg"
import DeleteIco from "../../../assets/icons/delete.svg"
import EditIco from "../../../assets/icons/edit.svg"
import CheckIco from "../../../assets/check_gray.svg"

import MemberImg from "../../../assets/u.jpeg"




import { useWindowSize } from "../../../hooks/useWindowSize";

import "../index.scss"
import AppManager from '../../../views/app/settings/AppManager';
import { appActions } from '../../../redux/actions/in-app';
import { VersionPageProps } from '../../../types/app/versionTypes';
import { StoreGroupsPageProps } from '../../../types/app/storeGroupsTypes';
import StoreTypeManager from '../../../views/app/settings/StoreTypeManager';
import AttributeTemplateManager from '../../../views/app/settings/AttributeTemplateManager';
import { MediaPageProps } from '../../../types/app/mediaTypes';
import { AttributeTemplatesPageProps } from '../../../types/app/attributeTemplateTypes';



const AddMemberModal = (props: any) => {
    let { showMemberModal, setShowMemberModal } = props;

    let detailsValidationSchema = Yup.object().shape({
        memberName: Yup.string()
            .required("Required"),
        memberRole: Yup.string()
            .required("Required"),
        memberEmail: Yup.string()
            .required("Required"),


    });
    let initialValues: any = {
        memberName: "",
        memberRole: "",
        memberEmail: "",
    }
    return (
        <Modal className="member_wrap" show={showMemberModal} onHide={() => setShowMemberModal(false)}>
            <Modal.Header closeButton>
                Add team member
            </Modal.Header>
            <Modal.Body>
                <div className="form_wrap">
                    <Formik
                        initialValues={initialValues}
                        validationSchema={detailsValidationSchema}
                        onSubmit={(values: any, actions) => { }}
                    >

                        {(props: FormikProps<any>) => {
                            const {
                                values,
                                touched,
                                errors,
                                setFieldTouched,
                                handleChange,
                                setFieldValue,
                            } = props;
                            return (
                                <Form>
                                    <div className="form-group">
                                        <div className="">
                                            <label htmlFor="memberName">
                                                Name
                                            </label>
                                            <Field
                                                value={values.memberName}
                                                name="memberName"
                                                id="memberName"
                                                autoComplete="off"
                                                type="text"
                                                placeholder="Enter team member’s name"
                                                onChange={handleChange}
                                                className={`input-wrap inapp-input ${errors.memberName && touched.memberName ?
                                                    "is-invalid-input "
                                                    : !errors.memberName && values.memberName !== "" ? "valid-input" : ""}`}
                                            >

                                            </Field>
                                            <ErrorMessage name="memberName" className="form-input-error" component="span" />
                                        </div>

                                    </div>
                                    <div className="form-group">
                                        <div className="">
                                            <label htmlFor="memberEmail">
                                                Email
                                            </label>
                                            <Field
                                                value={values.memberEmail}
                                                name="memberEmail"
                                                id="memberEmail"
                                                autoComplete="off"
                                                type="text"
                                                placeholder="sample@gmail.com"
                                                onChange={handleChange}
                                                className={`input-wrap inapp-input ${errors.memberEmail && touched.memberEmail ?
                                                    "is-invalid-input "
                                                    : !errors.memberEmail && values.memberEmail !== "" ? "valid-input" : ""}`}
                                            >

                                            </Field>
                                            <ErrorMessage name="memberEmail" className="form-input-error" component="span" />
                                        </div>

                                    </div>
                                    <div className="form-group">
                                        <div className="">
                                            <label htmlFor="memberRole">
                                                Role
                                            </label>
                                            <select
                                                value={values.memberRole}
                                                name="memberRole"
                                                id="memberRole"
                                                className={`input-wrap inapp-input ${errors.memberRole && touched.memberRole ?
                                                    "is-invalid-input "
                                                    : !errors.memberRole && values.memberRole !== "" ? "valid-input" : ""}`}>
                                                <option value="">Super Admin</option>
                                                <option value="">Manager</option>
                                                <option value="">Analyst</option>
                                                <option value="">Auditor</option>
                                            </select>
                                            {/* <Field
                                                value={values.productName}
                                                name="memberName"
                                                id="memberName"
                                                autoComplete="off"
                                                type="text"
                                                placeholder="sample@gmail.com"
                                                onChange={handleChange}
                                                className={`input-wrap inapp-input ${errors.memberName && touched.memberName ?
                                                    "is-invalid-input "
                                                    : !errors.memberName && values.memberName !== "" ? "valid-input" : ""}`}
                                            >

                                            </Field> */}
                                            <ErrorMessage name="memberName" className="form-input-error" component="span" />
                                        </div>

                                    </div>
                                    <div className="form-group">
                                        <button className="btn send_now" type="submit"> Send invite</button>
                                    </div>
                                </Form>
                            )
                        }}
                    </Formik>
                </div>

            </Modal.Body>
        </Modal>
    )

}


type SettingsPageProps = VersionPageProps &
    Pick<StoreGroupsPageProps,
        | "getStoreGroupsAction"
        | "getStoreGroupsRequest"
        | "getStoreGroupAction"
        | "getStoreGroupRequest"
        | "createStoreGroupAction"
        | "createStoreGroupRequest"
        | "updateStoreGroupAction"
        | "updateStoreGroupRequest"
        | "deleteStoreGroupAction"
        | "deleteStoreGroupRequest"
    > &
    Pick<AttributeTemplatesPageProps,
        | "getAttributeTemplatesAction"
        | "getAttributeTemplatesRequest"
        | "getAttributeTemplateAction"
        | "getAttributeTemplateRequest"
        | "createAttributeTemplateAction"
        | "createAttributeTemplateRequest"
        | "updateAttributeTemplateAction"
        | "updateAttributeTemplateRequest"
        | "deleteAttributeTemplateAction"
        | "deleteAttributeTemplateRequest"
    > &
    Pick<MediaPageProps,
        | "getImageGalleryAction"
        | "getImageGalleryRequest"
    >;

const InAppContent = ({ pageProps }: { pageProps: SettingsPageProps }) => {
    const [salesFlag, setSalesFlag] = useState(1);
    const screenResolution: any = useWindowSize();

    const [showMemberModal, setShowMemberModal] = useState<boolean>(false);
    const [activeTab, setActiveTab] = useState<'teams' | 'app' | 'store-type' | 'attribute-template'>('teams');
    const [underlineStyle, setUnderlineStyle] = useState<{ left: number; width: number }>({
        left: 0,
        width: 0,
    });
    const tabRefs = useRef<Record<'teams' | 'app' | 'store-type' | 'attribute-template', HTMLButtonElement | null>>({
        teams: null,
        app: null,
        'store-type': null,
        'attribute-template': null,
    });


    useEffect(() => {

    }, [])

    useLayoutEffect(() => {
        const updateUnderlinePosition = () => {
            const activeTabElement = tabRefs.current[activeTab];

            if (!activeTabElement) {
                return;
            }

            setUnderlineStyle({
                left: activeTabElement.offsetLeft,
                width: activeTabElement.offsetWidth,
            });
        };

        updateUnderlinePosition();
        window.addEventListener('resize', updateUnderlinePosition);

        return () => {
            window.removeEventListener('resize', updateUnderlinePosition);
        };
    }, [activeTab]);

    const ReportTable = () => {
        return (
            <>
                <thead>
                    <tr>
                        <th className="left_top"> <span >Name</span> </th>
                        <th> Role</th>
                        <th className="right_top centered"> <span>Actions</span> </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="brand_name">
                            <div className="team_member ">
                                <input type="checkbox" name="" id="" />
                                <img src={MemberImg} alt="" />
                                <div className="member_info">
                                    <div className="member_name"> Alexandra Dubois</div>
                                    <div className="member_email"> jkimmich@gmail.com</div>
                                </div>
                            </div>

                        </td>
                        <td>
                            <select name="" id="" className="admin_roles level1">
                                <option value="">Super Admin</option>
                                <option value="">Analyst</option>
                                <option value="">Manager</option>
                                <option value="">Author</option>
                            </select>
                        </td>
                        <td>
                            <div className="action_ctas centered">
                                <button>
                                    <img src={EditIco} alt="" />
                                </button>
                                <button>
                                    <img src={DeleteIco} alt="" />
                                </button>
                            </div>
                        </td>

                    </tr>
                    <tr>
                        <td className="brand_name">
                            <div className="team_member ">
                                <input type="checkbox" name="" id="" />
                                <img src={MemberImg} alt="" />
                                <div className="member_info">
                                    <div className="member_name"> Alexandra Dubois</div>
                                    <div className="member_email"> jkimmich@gmail.com</div>
                                </div>
                            </div>

                        </td>
                        <td>
                            <select name="" id="" className="admin_roles level2">
                                <option value="">Analyst</option>
                                <option value="">Super Admin</option>
                                <option value="">Manager</option>
                                <option value="">Author</option>
                            </select>
                        </td>
                        <td>
                            <div className="action_ctas centered">
                                <button>
                                    <img src={EditIco} alt="" />
                                </button>
                                <button>
                                    <img src={DeleteIco} alt="" />
                                </button>
                            </div>
                        </td>

                    </tr>
                    <tr>
                        <td className="brand_name">
                            <div className="team_member ">
                                <input type="checkbox" name="" id="" />
                                <img src={MemberImg} alt="" />
                                <div className="member_info">
                                    <div className="member_name"> Alexandra Dubois</div>
                                    <div className="member_email"> jkimmich@gmail.com</div>
                                </div>
                            </div>

                        </td>
                        <td>
                            <select name="" id="" className="admin_roles level3">
                                <option value="">Manager</option>
                                <option value="">Super Admin</option>
                                <option value="">Analyst</option>
                                <option value="">Author</option>
                            </select>
                        </td>
                        <td>
                            <div className="action_ctas centered">
                                <button>
                                    <img src={EditIco} alt="" />
                                </button>
                                <button>
                                    <img src={DeleteIco} alt="" />
                                </button>
                            </div>
                        </td>

                    </tr>
                    <tr>
                        <td className="brand_name">
                            <div className="team_member ">
                                <input type="checkbox" name="" id="" />
                                <img src={MemberImg} alt="" />
                                <div className="member_info">
                                    <div className="member_name"> Alexandra Dubois</div>
                                    <div className="member_email"> jkimmich@gmail.com</div>
                                </div>
                            </div>

                        </td>
                        <td>
                            <select name="" id="" className="admin_roles level4">
                                <option value="">Author</option>
                                <option value="">Manager</option>
                                <option value="">Super Admin</option>
                                <option value="">Analyst</option>
                            </select>
                        </td>
                        <td>
                            <div className="action_ctas centered">
                                <button>
                                    <img src={EditIco} alt="" />
                                </button>
                                <button>
                                    <img src={DeleteIco} alt="" />
                                </button>
                            </div>
                        </td>

                    </tr>



                </tbody>
            </>
        )
    }


    const ReportsDisplay = () => {
        return (
            <div className="reports_wrap">
                <AddMemberModal showMemberModal={showMemberModal} setShowMemberModal={setShowMemberModal} />
                <div className="report_head_wrap">
                    <div className="report_head_left">
                        <div className="report_heading">Team Management</div>
                        <div className="report_desc">Add team members, and assign roles</div>
                    </div>
                    <div className="report_head_right">
                        <div className="report_head_cta">
                            {/* <button>
                                <img src={ExportIco} alt="" />
                                <span>Export database</span>
                            </button> */}
                            <button className="shaded" onClick={() => setShowMemberModal(true)}>
                                <img src={TeamIco} alt="" />
                                <span>Add team member</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div className="reports_table">
                    <div className="teams_wrap">
                        <div className="left_side">
                            <div className="top_filter">
                                <input type="text" className="search_table" placeholder="Search" />
                                <div className="filter_wrap">
                                    <img src={FilterIco} alt="" />
                                    <select name="" id="">
                                        <option value="">Filter By role</option>
                                    </select>
                                </div>
                            </div>
                            <TableComponent
                                childComponent={<ReportTable />}

                            />
                        </div>
                        <div className="right_side">
                            <div className="permissions_wrap">
                                <div className="header_msg">
                                    <div className="main">Permissions</div>
                                    <div className="helper">Grant permissions for each role</div>
                                </div>
                                <div className="all_permissions">
                                    <div className="each_permisison">
                                        <div className="permission_name">Create and edit blog posts</div>
                                        <div className="all_roles">
                                            <div className="role_check">
                                                <input type="checkbox" name="" id="" />
                                                <label htmlFor="">Super Admin</label>
                                            </div>
                                            <div className="role_check">
                                                <input type="checkbox" name="" id="" />
                                                <label htmlFor="">Manager</label>
                                            </div>
                                            <div className="role_check">
                                                <input type="checkbox" name="" id="" />
                                                <label htmlFor="">Author</label>
                                            </div>
                                            <div className="role_check">
                                                <input type="checkbox" name="" id="" />
                                                <label htmlFor="">Analyst</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="each_permisison">
                                        <div className="permission_name">Edit permission</div>
                                        <div className="all_roles">
                                            <div className="role_check">
                                                <input type="checkbox" name="" id="" />
                                                <label htmlFor="">Super Admin</label>
                                            </div>
                                            <div className="role_check">
                                                <input type="checkbox" name="" id="" />
                                                <label htmlFor="">Manager</label>
                                            </div>
                                            <div className="role_check">
                                                <input type="checkbox" name="" id="" />
                                                <label htmlFor="">Author</label>
                                            </div>
                                            <div className="role_check">
                                                <input type="checkbox" name="" id="" />
                                                <label htmlFor="">Analyst</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="each_permisison">
                                        <div className="permission_name">Export datasets</div>
                                        <div className="all_roles">
                                            <div className="role_check">
                                                <input type="checkbox" name="" id="" />
                                                <label htmlFor="">Super Admin</label>
                                            </div>
                                            <div className="role_check">
                                                <input type="checkbox" name="" id="" />
                                                <label htmlFor="">Manager</label>
                                            </div>
                                            <div className="role_check">
                                                <input type="checkbox" name="" id="" />
                                                <label htmlFor="">Author</label>
                                            </div>
                                            <div className="role_check">
                                                <input type="checkbox" name="" id="" />
                                                <label htmlFor="">Analyst</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="each_permisison">
                                        <div className="permission_name">Inventory management</div>
                                        <div className="all_roles">
                                            <div className="role_check">
                                                <input type="checkbox" name="" id="" />
                                                <label htmlFor="">Super Admin</label>
                                            </div>
                                            <div className="role_check">
                                                <input type="checkbox" name="" id="" />
                                                <label htmlFor="">Manager</label>
                                            </div>
                                            <div className="role_check">
                                                <input type="checkbox" name="" id="" />
                                                <label htmlFor="">Author</label>
                                            </div>
                                            <div className="role_check">
                                                <input type="checkbox" name="" id="" />
                                                <label htmlFor="">Analyst</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="each_permisison">
                                        <div className="permission_name">Resolve vendor issues</div>
                                        <div className="all_roles">
                                            <div className="role_check">
                                                <input type="checkbox" name="" id="" />
                                                <label htmlFor="">Super Admin</label>
                                            </div>
                                            <div className="role_check">
                                                <input type="checkbox" name="" id="" />
                                                <label htmlFor="">Manager</label>
                                            </div>
                                            <div className="role_check">
                                                <input type="checkbox" name="" id="" />
                                                <label htmlFor="">Author</label>
                                            </div>
                                            <div className="role_check">
                                                <input type="checkbox" name="" id="" />
                                                <label htmlFor="">Analyst</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="each_permisison">
                                        <div className="permission_name">Access control</div>
                                        <div className="all_roles">
                                            <div className="role_check">
                                                <input type="checkbox" name="" id="" />
                                                <label htmlFor="">Super Admin</label>
                                            </div>
                                            <div className="role_check">
                                                <input type="checkbox" name="" id="" />
                                                <label htmlFor="">Manager</label>
                                            </div>
                                            <div className="role_check">
                                                <input type="checkbox" name="" id="" />
                                                <label htmlFor="">Author</label>
                                            </div>
                                            <div className="role_check">
                                                <input type="checkbox" name="" id="" />
                                                <label htmlFor="">Analyst</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="save_cta">
                                    <button className='btn'>
                                        <img src={CheckIco} alt="" />
                                        Save Changes
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        )
    }


    return (
        <div className="inapp-content">
            <div className="settings-tabs-row">
                <div className="tabs settings-tabs">
                    <button ref={(node) => { tabRefs.current.teams = node; }} onClick={() => setActiveTab('teams')} className={`tab ${activeTab === 'teams' && 'active'}`}>Teams Manager</button>
                    <button ref={(node) => { tabRefs.current.app = node; }} onClick={() => setActiveTab('app')} className={`tab ${activeTab === 'app' && 'active'}`}>App Manager</button>
                    <button ref={(node) => { tabRefs.current['store-type'] = node; }} onClick={() => setActiveTab('store-type')} className={`tab ${activeTab === 'store-type' && 'active'}`}>Store Type</button>
                    <button ref={(node) => { tabRefs.current['attribute-template'] = node; }} onClick={() => setActiveTab('attribute-template')} className={`tab ${activeTab === 'attribute-template' && 'active'}`}>Attribute Template</button>

                    <span className="underline" style={{ left: underlineStyle.left, width: underlineStyle.width }}></span>
                </div>
            </div>
            <hr />
            <div className="page-content dashboard">
                {activeTab === 'teams' ? (
                    <ReportsDisplay />
                ) : activeTab === 'app' ? (
                    <AppManager pageProps={pageProps} />
                ) : activeTab === 'store-type' ? (
                    <StoreTypeManager pageProps={pageProps} />
                ) : (
                    <AttributeTemplateManager pageProps={pageProps} />
                )}
            </div>
        </div>
    )
}

const SettingsManagement = (pageProps: SettingsPageProps | any) => {
    return (
        <InAppTemplate pageHeadingTitle="Settings Management" childComponent={<InAppContent pageProps={pageProps} />} />
    )
}


const mapDispatchToProps = {
    updateVersionAction: appActions.updateVersion,
    getVersionsAction: appActions.GetVersions,
    createVersionAction: appActions.createVersion,
    getStoreGroupsAction: appActions.GetStoreGroups,
    getStoreGroupAction: appActions.GetStoreGroup,
    createStoreGroupAction: appActions.CreateStoreGroup,
    updateStoreGroupAction: appActions.UpdateStoreGroup,
    deleteStoreGroupAction: appActions.DeleteStoreGroup,
    getAttributeTemplatesAction: appActions.GetAttributeTemplates,
    getAttributeTemplateAction: appActions.GetAttributeTemplate,
    createAttributeTemplateAction: appActions.CreateAttributeTemplate,
    updateAttributeTemplateAction: appActions.UpdateAttributeTemplate,
    deleteAttributeTemplateAction: appActions.DeleteAttributeTemplate,
    getImageGalleryAction: appActions.GetImageGallery,
};

const mapStateToProps = (state: any) => ({
    updateVersionRequest: state.allInAppReducers.updateVersionReducer,
    getVersionsRequest: state.allInAppReducers.getVersionsReducer,
    createVersionRequest: state.allInAppReducers.createVersionReducer,
    getStoreGroupsRequest: state.allInAppReducers.getStoreGroupsReducer,
    getStoreGroupRequest: state.allInAppReducers.getStoreGroupReducer,
    createStoreGroupRequest: state.allInAppReducers.createStoreGroupReducer,
    updateStoreGroupRequest: state.allInAppReducers.updateStoreGroupReducer,
    deleteStoreGroupRequest: state.allInAppReducers.deleteStoreGroupReducer,
    getAttributeTemplatesRequest: state.allInAppReducers.getAttributeTemplatesReducer,
    getAttributeTemplateRequest: state.allInAppReducers.getAttributeTemplateReducer,
    createAttributeTemplateRequest: state.allInAppReducers.createAttributeTemplateReducer,
    updateAttributeTemplateRequest: state.allInAppReducers.updateAttributeTemplateReducer,
    deleteAttributeTemplateRequest: state.allInAppReducers.deleteAttributeTemplateReducer,
    getImageGalleryRequest: state.allInAppReducers.getImageGalleryReducer,
})
export default connect(mapStateToProps, mapDispatchToProps)(SettingsManagement);
